import { useGetDncEntriesQuery } from "@/store/rest_api";
import type DncEntry from "@/model/interface/DncEntry";
import type { DncType } from "@/model/interface/DncEntry";

const MINIMUM_PHONE_DIGITS = 10;

const TEXT_BLOCKING_TYPES: DncType[] = ["DNC", "BOTH", "DNT"];

export function useTextBlockingEntry(phoneNumbers: string[]): DncEntry | null {
  const checkableNumbers = phoneNumbers
    .map((phoneNumber) => phoneNumber.trim())
    .filter((phoneNumber) => phoneNumber.replace(/\D/g, "").length >= MINIMUM_PHONE_DIGITS);
  const { currentData } = useGetDncEntriesQuery(
    { phoneNumbers: checkableNumbers },
    { skip: checkableNumbers.length === 0 },
  );

  if (checkableNumbers.length === 0 || !currentData) {
    return null;
  }
  const blockingEntries = currentData.items.filter((entry) => TEXT_BLOCKING_TYPES.includes(entry.type));
  return blockingEntries.find((entry) => entry.type !== "DNT") ?? blockingEntries[0] ?? null;
}
